module.exports = __webpack_public_path__ + "img/ic-map-facility-big.f5f9b836.svg";